module.exports = __webpack_public_path__ + "logo3.png?9443df4efd0885bc14aeb5b7d221fb37";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo3.png
// module id = 315
// module chunks = 2